import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-production",
  "use": "icon-leo-e1-production-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-production\">\r\n<g transform=\"translate(-161.415 -189.709) scale(1.414737)\">\r\n<path d=\"M192 192h400v72H192V192zm40 104h320l40 400c6 64-42 112-106 112H298c-64 0-112-48-106-112l40-400zm88 88l-24 256h216l-24-256H320z\" />\r\n  <path d=\"M672 288h88c88 0 160 72 160 160s-72 160-160 160h-40v-72h40c48 0 88-40 88-88s-40-88-88-88h-88V288z\" />\r\n  <path d=\"M560 640a80 80 0 1 1 0 160 80 80 0 0 1 0-160zm0 56a24 24 0 1 0 0 48 24 24 0 0 0 0-48zm192-56a80 80 0 1 1 0 160 80 80 0 0 1 0-160zm0 56a24 24 0 1 0 0 48 24 24 0 0 0 0-48z\" />\r\n  <path d=\"M640 696h96v48h-96v-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-production.svg
// module id = lO5h
// module chunks = 478